export default __webpack_public_path__ + "static/door7-e4f2960b84422754a8471fd213b2bcf6.jpg";